import axios from "axios";

export const FETCH_HEADER_NAVIGATION = "AKASHA_FETCH_HEADER_NAVIGATION";
export const FETCH_HEADER_NAVIGATION_FULFILLED = `${FETCH_HEADER_NAVIGATION}_FULFILLED`;
export const FETCH_HEADER_NAVIGATION_PENDING = `${FETCH_HEADER_NAVIGATION}_PENDING`;
export const FETCH_HEADER_NAVIGATION_REJECTED = `${FETCH_HEADER_NAVIGATION}_REJECTED`;

export function getNavigation(
  isLoggedIn: boolean,
  languageCode: string,
  additionalHeaders?: any
) {
  return {
    type: FETCH_HEADER_NAVIGATION,
    payload: axios.get(`${process.env.REACT_APP_NAVIGATION_SERVICE_ENDPOINT}`, {
      headers: {
        ...additionalHeaders,
        "Customer-Facing-Tool": process.env.REACT_APP_CFT,
        CFT: process.env.REACT_APP_CFT,
        MSessionId: sessionStorage.getItem("sessionId"),
      },
      params: { languageCode },
    }),
    meta: { isLoggedIn },
  };
}
